import lottie from '../utils/rbata.lottie';

const heroDetailArea = {
    heroDetailWrapper:     undefined,
    heroDetailTiles:       undefined,
    heroDetailTilesMobile: undefined,

    init() {
        this.heroDetailWrapper = $('.pdp__hero-detail');
        this.heroDetailTiles = this.heroDetailWrapper.find('.pdp__hero-detail-tile');

        if (this.heroDetailWrapper.length) {
            lottie.cacheLottie();
            lottie.instantiateLottie();
        }
    }
}

$(() => {
    heroDetailArea.init();
});

export default heroDetailArea;